module.exports = __webpack_public_path__ + "f0460d1ba320b37d87799fbedafa7af9.svg";